"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { forwardRef } from "react";
import { TransitionGroup, Transition } from "react-transition-group";
import Button, { ButtonType } from "../Button/Button";
import Tooltip from "../Tooltip/Tooltip";
import { AnimationDuration } from "../../../styles/Animations";
import forceReflow from "../../../utils/forceReflow";
import * as styles from "./IconButton-css";
const IconButton = forwardRef(
  (_a, ref) => {
    var _b = _a, { type, icon, disabled, tooltip, disabledReason, "aria-label": ariaLabel, size } = _b, buttonProps = __objRest(_b, ["type", "icon", "disabled", "tooltip", "disabledReason", "aria-label", "size"]);
    const tooltipContent = disabled && !!disabledReason ? disabledReason : tooltip == null ? void 0 : tooltip.content;
    const tooltipBasedLabel = (tooltip == null ? void 0 : tooltip.show) ? void 0 : tooltip == null ? void 0 : tooltip.content.toString();
    const renderButton = () => {
      var _a2;
      return /* @__PURE__ */ React.createElement(
        Button,
        __spreadValues({
          isIconOnly: true,
          disabled,
          type,
          ref,
          size,
          "aria-label": ariaLabel || tooltipBasedLabel
        }, buttonProps),
        /* @__PURE__ */ React.createElement(TransitionGroup, { component: null }, /* @__PURE__ */ React.createElement(Transition, { onEnter: forceReflow, key: (_a2 = icon.key) != null ? _a2 : void 0, timeout: AnimationDuration.Medium }, (status) => /* @__PURE__ */ React.createElement("div", { className: styles.iconWrapper({ status }) }, icon)))
      );
    };
    if (tooltip) {
      return /* @__PURE__ */ React.createElement(Tooltip, __spreadProps(__spreadValues({ wrapTarget: disabled }, tooltip), { content: tooltipContent != null ? tooltipContent : "" }), renderButton());
    }
    return renderButton();
  }
);
IconButton.defaultProps = {
  type: ButtonType.Tertiary
};
export default IconButton;
